var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2261 11.75C14.8461 11.75 16.9761 9.62 16.9761 7C16.9761 4.38 14.8461 2.25 12.2261 2.25C9.60607 2.25 7.47607 4.38 7.47607 7C7.47607 9.62 9.60607 11.75 12.2261 11.75ZM12.2261 3.75C14.0161 3.75 15.4761 5.21 15.4761 7C15.4761 8.79 14.0161 10.25 12.2261 10.25C10.4361 10.25 8.97607 8.79 8.97607 7C8.97607 5.21 10.4361 3.75 12.2261 3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2361 14.7598C15.1061 12.7598 9.34607 12.7598 4.21607 14.7598C3.15607 15.1698 2.47607 16.1798 2.47607 17.3198V18.9998C2.47607 20.5198 3.70607 21.7498 5.22607 21.7498H19.2261C20.7461 21.7498 21.9761 20.5198 21.9761 18.9998V17.3198C21.9761 16.1798 21.2961 15.1698 20.2361 14.7598ZM20.4761 18.9998C20.4761 19.6898 19.9161 20.2498 19.2261 20.2498H5.22607C4.53607 20.2498 3.97607 19.6898 3.97607 18.9998V17.3198C3.97607 16.7998 4.28607 16.3398 4.76607 16.1598C7.15607 15.2298 9.66607 14.7498 12.2261 14.7498C14.7861 14.7498 17.2961 15.2198 19.6861 16.1598C20.1661 16.3498 20.4761 16.7998 20.4761 17.3198V18.9998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users_icon.c6c203f93cec47994cca3259386f9062.svg";
export { ForwardRef as ReactComponent };